module.exports = __webpack_public_path__ + "img/sub-intro-tab.2d42d58e.png";